<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="this.videoInfo.vod_name" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="movie-video">
      <video id="my-video" class="video-js"></video>
      <!-- 外链页面型视频（如 tube8 页面地址）：播放器无法解析，展示封面+“前往观看”新标签打开 -->
      <div v-if="externalUrl" class="external-watch" @click="openExternal">
        <img :src="cover" class="external-poster" />
        <div class="external-btn">{{ $t('video.external_watch') }}</div>
      </div>
    </div>
    <div class="movie-content">
      <div class="movie-descript">
        <p>{{ this.videoInfo.vod_name }}</p>
        <span>{{ this.videoInfo.count }}{{ $t("video.num_play") }}</span>
      </div>

      <div class="movie-body">
        <div class="movie-title">
          <div>
            <span>{{ $t("index.recmonmand") }}</span>
          </div>
        </div>
      </div>
      <div  class="hotlist">
        <div  v-for="(v,key) in moreVideoInfo" :key="key" @click="toPlayVideo(v.id)">
          <img
            
            :src="v.vod_pic"
          />
          <div >
            <span >{{ v.vod_name }}</span
            ><span >{{$t("video.play")}}:{{ v.count }}</span>
          </div>
        </div>
     
      </div>
    </div>
  </div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
  data() {
    return {
      nowPlayVideoUrl: "",
      externalUrl: "",
      cover: "",
      userInfo: [],
      videoInfo: {},
      moreVideoInfo: {},
      player: null,
      is_play: false,
      times: null,
      is_see: 0,
    };
  },
  methods: {
    back() {
      this.$router.push({ path: "/Video" });
    },
    getVideoInfo() {
      this.$http({
        method: "get",
        data: { id: this.$route.query.id },
        url: "video_get_info",
      }).then((res) => {
        this.videoInfo = res.data;
        this.nowPlayVideoUrl = this.videoInfo.vod_play_url;
        this.cover = this.videoInfo.vod_pic;
        let videos = document.getElementById("my-video");
     
        videos.poster = this.cover;
        this.getVideo();
      });
    },
    toPlayVideo(id) {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        this.$router.push({ path: "?id=" + id });
        location.reload();
      }
    },
    getMoreVideoItem() {
      this.$http({
        method: "get",
        url: "video_get_more_item",
      }).then((res) => {
        this.moreVideoInfo = res.data;
      });
    },
    getVideo() {
      const url = this.nowPlayVideoUrl || "";
      // 外链页面地址（非 m3u8/mp4 直链）播放器无法解析：展示封面并提供“前往观看”新标签打开
      if (!this.isDirectStream(url)) {
        this.externalUrl = url;
        this.player.poster(this.cover);
        return;
      }
      this.externalUrl = "";
      const type = /\.(mp4|mov|webm|ogg)([?#]|$)/i.test(url) ? "video/mp4" : "application/x-mpegURL";
      this.player.src([
        {
          src: url,
          type: type, // m3u8 走 hls 流，mp4 走原生播放
        },
      ]);
      this.player.poster(this.cover);
    },
    // 判断是否为可直接播放的流媒体直链（m3u8/mp4 等），否则视为外链页面
    isDirectStream(url) {
      return /\.(m3u8|m4u8|mp4|mov|webm|ogg)([?#]|$)/i.test(url);
    },
    openExternal() {
      if (this.externalUrl) window.open(this.externalUrl, "_blank");
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.is_see = this.userInfo.is_see;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("video.account_out"));
            const _lang = localStorage.getItem('lang'); localStorage.clear(); if (_lang) localStorage.setItem('lang', _lang); // 账号异常清登录态但保留语言设置
            this.$router.push({ path: "/Login" });
          } else {
            if (this.$store.getters.getBaseInfo.isplay == 1) {
              this.getVideoInfo();
              this.getMoreVideoItem();
              // if(this.userInfo.money <= "0.00"){
              //   this.$toast(this.$t("video.buy"));
              //   this.$router.push({path:'/Home'})
              // }
            } else {
              this.getVideoInfo();
              this.getMoreVideoItem();
            }
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
     
        this.player = videojs(
          "my-video",
          {
            height: "200px",
            preload: "auto", // 预加载
            controls: true, // 显示播放的控件
            multipleArray: [0.75, 1, 1.5, 2], // 倍速设置
          },
          function () {
            this.on("play", () => {
              _this.is_play = true;
            });
          }
        );
      
      this.getUserInfo();
      this.times = setInterval(() => {
        if (this.is_play && this.is_see == 0) {
          const ct = Math.round(this.player.currentTime());
          if (ct >= 180) {
            this.player.pause();
            this.$toast(this.$t("video.buy"));
            return;
          }
        }
      }, 1000 * 2);
    }
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
      this.player = null;
    }
    if (this.is_play) {
      this.is_play = false;
    }
    clearInterval(this.times);
  },
};
</script>

<style scoped>
.movie-video {
  position: relative;
}
/* 外链页面型视频：封面铺满播放区，中央“前往观看”按钮，点击新标签打开 */
.external-watch {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  cursor: pointer;
  background: #000;
}
.external-poster {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.85;
}
.external-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 16px 48px;
  border-radius: 40px;
  background: linear-gradient(90deg, #efcba7, #dcab76);
  color: #623a13;
  font-size: 28px;
  font-weight: 700;
}
.video-js {
  width: 100%;
  /*height: 420px;*/
  font-size: 24px;
}
.movie-content {
  flex: 1;
  overflow-y: auto;
}
.movie-content .movie-descript {
  width: 100%;
  /* height: 140px; */
  /* background-color: #fff; */
  color: #f3c7a2;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  padding: 15px;
}
.movie-content .movie-descript p {
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}
.movie-content .movie-descript span {
  color: rgb(170, 45, 220);
  font-size: 0.8rem;
  background: rgb(242, 242, 245);
  padding: 10px;
  border-radius: 16px;
}
.movie-content .movie-body {
  width: calc(100% - 20px);
  margin: 0 auto;
}
::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}
.movie-content .movie-body .movie-title {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
}
.movie-content .movie-body .movie-title > div:first-child {
  width: 410px;
}
.movie-content .movie-body .movie-title > div:first-child span {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 30px;
  font-weight: 700;
  color: #f3c7a2;
}
.movie-content .movie-body .movie-title > div:first-child span:before {
  content: "";
  display: block;
  width: 8px;
  height: 30px;
  background-color: #7e5678;
  border-radius: 25px;
  margin-right: 10px;
}

abbr,
address,
article,
aside,
audio,
b,
blockquote,
body,
canvas,
caption,
cite,
code,
dd,
del,
details,
dfn,
div,
dl,
dt,
em,
fieldset,
figcaption,
figure,
footer,
form,
h1,
h2,
h3,
h4,
h5,
h6,
header,
hgroup,
html,
i,
iframe,
img,
ins,
kbd,
label,
legend,
li,
mark,
menu,
nav,
object,
ol,
p,
pre,
q,
samp,
section,
small,
span,
strong,
sub,
summary,
sup,
table,
tbody,
td,
tfoot,
th,
thead,
time,
tr,
ul,
var,
video {
  margin: 0;
  padding: 0;
  border: 0;
  outline: 0;
  font-size: 100%;
  vertical-align: baseline;
  box-sizing: border-box;
}

.vjs-big-play-button .vjs-icon-placeholder {
  font-size: 1.63em !important;
}
.hotlist{
  display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.hotlist div{
  position: relative;
    width: calc(50% - 10px);
    border-radius: 16px;
    overflow: hidden;
    margin-bottom: 20px;
}
.hotlist div img{
  width: 100%;
  height: 27vw;
}
.hotlist div div{
  position: absolute;
    bottom: 20px;
    width: 100%;
    left: 0;
    background: rgba(0, 0, 0, .4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3vw;
    height: 8vw;
    border-radius: 16px;
}
.hotlist div div span{
  width: 50%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    padding-left: 20px;
}
</style>
